"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataAlign = exports.DataComponents = void 0;
var DataComponents;
(function (DataComponents) {
    DataComponents[DataComponents["TRANSACTION_STATUS_TAG"] = 0] = "TRANSACTION_STATUS_TAG";
    DataComponents[DataComponents["PAYMENT_METHOD"] = 1] = "PAYMENT_METHOD";
    DataComponents[DataComponents["TRANSACTION_TYPE"] = 2] = "TRANSACTION_TYPE";
    DataComponents[DataComponents["CURRENCY"] = 3] = "CURRENCY";
    DataComponents[DataComponents["TOFROM"] = 4] = "TOFROM";
})(DataComponents = exports.DataComponents || (exports.DataComponents = {}));
var DataAlign;
(function (DataAlign) {
    DataAlign[DataAlign["LEFT"] = 0] = "LEFT";
    DataAlign[DataAlign["CENTER"] = 1] = "CENTER";
    DataAlign[DataAlign["RIGHT"] = 2] = "RIGHT";
})(DataAlign = exports.DataAlign || (exports.DataAlign = {}));
